import type {
  Benefits,
  CustomDirectusTypes,
  DirectusFiles,
  EmployerBrand,
  EmployerBrandFiles,
} from '@funnellab/shared/src/types/directus.ts';
import type { CollectionType, QueryItem } from '@directus/sdk';

export type EmployerBrandBenefits = {
  id: number;
  benefits_id: Required<Pick<Benefits, 'label' | 'id' | 'icon'>>;
};

export type EmployerBrandCiDocument = Pick<EmployerBrandFiles, 'id'> & {
  directus_files_id: Required<
    Pick<DirectusFiles, 'id' | 'filename_download' | 'filesize'>
  >;
};
export type EmployerBrandDto = Required<
  Pick<
    EmployerBrand,
    | 'id'
    | 'name'
    | 'status'
    | 'ownerOrganization'
    | 'description'
    | 'ciGuidelines'
    | 'homepage'
  >
> & {
  benefits: EmployerBrandBenefits[];
  ciDocuments: EmployerBrandCiDocument[];
};

export const employerBrandQuery = {
  fields: [
    'id',
    'name',
    'status',
    'ownerOrganization',
    'description',
    'ciGuidelines',
    'homepage',
    {
      ciDocuments: [
        'id',
        { directus_files_id: ['id', 'filename_download', 'filesize'] },
      ],
      benefits: ['id', { benefits_id: ['label', 'id', 'icon'] }],
    },
  ],
  sort: '-date_created',
} as const satisfies QueryItem<
  CustomDirectusTypes,
  CollectionType<CustomDirectusTypes, 'employerBrand'>
>;
